import React from 'react';

const GradCap: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M92.872 33.806l-42.077-16.67a2.358 2.358 0 00-1.581 0L7.138 33.806c-.441.182-.441.467 0 .648l16.799 6.663c-1.763.778-1.919 1.115-2.022 1.374-.856 1.893-.778 20.43-.752 24.136h1.504a211.144 211.144 0 01.596-23.332c.285-.285 20.74-9.644 22.244-10.215l-18.148 9.54 21.777 8.634c.511.182 1.07.182 1.581 0l42.077-16.67c.518-.415.518-.596.078-.778z"
    ></path>
    <path
      fill="currentColor"
      d="M49.992 54a5.185 5.185 0 01-1.815-.312L27.1 45.315v17.37c0 2.825 10.37 5.184 22.892 5.184s22.918-2.307 22.918-5.185v-17.37l-21.103 8.374a5.186 5.186 0 01-1.815.311zM23.73 71.808v-3.319c0-.803-1.71-.855-1.71-.855s-1.686 0-1.686.855v3.319c0 .751 1.686.751 1.686.751s1.71 0 1.71-.751zm0 1.245a3.422 3.422 0 01-3.267 0c-1.659.804-1.788 3.76-1.788 5.185a8.815 8.815 0 01-.804 3.163l1.27 1.581a5.937 5.937 0 00.7-3.422 4.33 4.33 0 01.182-2.592c.026.661.104 1.32.233 1.97a24.42 24.42 0 01-.415 4.252c.13.207 1.919.803 2.385-.285.316-1.788.429-3.606.337-5.419l.363 1.426c.179 1.4.118 2.82-.181 4.2.463.085.937.085 1.4 0 .544-.156.777-.467.466-1.115a20.743 20.743 0 01.363-5.055 4.693 4.693 0 00-1.244-3.889z"
    ></path>
  </svg>
);

export default GradCap;
